<template>
  <div>
    <object-internals
      :object-number="objectData.objectNumber"
    />

    <info-label
      :object-data="objectData"
    />
    <ul class="basics d-none d-sm-block">
      <li>
        <i class="icon"><icon-building v-if="objectData.objectType === 'apartment'" /><icon-home v-else /></i>
        {{ checkObjectType }}
      </li>
      <li v-if="objectData.personsMax > 0">
        <i class="icon"><icon-user-friends /></i>
        {{ $t('common:keyData.person', {count:objectData.personsMax}) }}
      </li>
      <li v-if="objectData.countRoomsSleeping > 0">
        <i class="icon"><icon-bed /></i>
        {{ $t('common:keyData.countRoomsSleeping',{count: objectData.countRoomsSleeping}) }}
      </li>
      <li v-if="objectData.squaremeterLiving > 0">
        <i class="icon"><icon-ruler-combined /></i>
        {{ objectData.squaremeterLiving }}{{ $t('common:keyData.squaremeterLiving') }}
      </li>
    </ul>
    <div class="d-sm-none d-block my-1">
      {{ $t('common:keyData.objectTypeWithDot', {typeOfObj:checkObjectType}) }}
      <span v-if="objectData.personsMax > 0"> {{ $t('common:keyData.person', {count:objectData.personsMax}) }} </span>
      <span v-if="objectData.countRoomsSleeping > 0"> {{ $t('common:keyData.midDot') }} </span>
      <span v-if="objectData.countRoomsSleeping > 0">{{ $t('common:keyData.short.countRoomsSleeping',
                                                           {count: objectData.countRoomsSleeping}) }}</span>
      <span v-if="objectData.squaremeterLiving > 0"> {{ $t('common:keyData.midDot') }} </span>
      <span v-if="objectData.squaremeterLiving > 0"> {{ $t('common:keyData.short.squaremeterLiving',
                                                           {count:objectData.squaremeterLiving}) }}</span>
    </div>
  </div>
</template>

<script>
/** components */
import ObjectInternals from 'components/ObjectInternals.vue';

/** Client Component */
import InfoLabel from 'components/InfoLabel.vue';

/** Icons */
import IconHome from 'ICON:IconHome';
import IconBuilding from 'ICON:IconBuilding';
import IconRulerCombined from 'ICON:IconRulerCombined';
import IconBed from 'ICON:IconBed';
import IconUserFriends from 'ICON:IconUserFriends';

/** Tooltip */
import { VBTooltip } from 'bootstrap-vue';
import 'scss/bootstrap/vue/components/tooltip.scss';

export default {
  name: 'SearchObjectBasics',
  components: {
    ObjectInternals,
    IconRulerCombined,
    IconBed,
    IconUserFriends,
    IconHome,
    IconBuilding,
    InfoLabel,

  },
  directives: { 'b-tooltip': VBTooltip },
  props: {
    objectData: {
      required: true,
      type: Object,
    },
  },
  i18nOptions: { namespaces: ['object'] },
  computed: {
    // used as a fallback option if there is no data about the type of the object
    checkObjectType() {
      if (this.objectData.objectType) {
        return `${this.$t(`common:keyData.objectType.${this.objectData.objectType}`)} `;
      }
      return `${this.$t('object:objectNumberShort')} ${this.objectData.objectNumber}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  ul.basics {
    @include font_size_s;

    margin: 0.5em 0;
    padding: 0;

    li {
      list-style: none;
      margin: 0.15em 0;
      padding: 0;

      .icon {
        margin: 0 0.25em 0 0;
      }
    }
    &.autoWidth{
      display:inline-block;
      .onrequest{
        color:$color_ci_complement;
      }
    }
  }
</style>
